module.exports = __webpack_public_path__ + "img/products.42113592.svg";